import React, { useState } from "react";
import { Box, Button, TextField, Stack } from "@mui/material";
import { apiRequest } from "../../utils/config/apiRequest";
import { apiUrl } from "../../utils/endPoints/apiUrl";
import { USERTYPE_ENUM } from "../../utils/Constant";

export default function ReplyBox({ ticketId, onSuccess }) {

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendReply = async () => {
    if (!message.trim()) return;

    setLoading(true);

    const { status } = await apiRequest({
      method: "POST",
      endUrl: apiUrl.complaints.complaintsResponse, 
      body: {
        ticketId: ticketId,
        response:message,
        responder: USERTYPE_ENUM.VENDOR
      },
      showMsg: true,
    });

    setLoading(false);

    if (status) {
      setMessage("");
      onSuccess && onSuccess();
    }
  };

  return (
    <Stack spacing={1}>
      <TextField
        multiline
        minRows={3}
        placeholder="Write your response..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        fullWidth
      />

      <Box textAlign="right">
        <Button
          variant="contained"
          size="small"
          onClick={sendReply}
          disabled={loading}
        >
          Send Reply
        </Button>
      </Box>
    </Stack>
  );
}
